import { Popover } from "@mui/material";
import React from "react";

const BasePopover = ({
  children,
  anchorOrigin,
  onClose,
  anchorEl,
  open,
  closeOnOutsideClick = false,
}) => {
  const id = open ? "simple-popover" : undefined;
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={closeOnOutsideClick ? onClose : null}
      anchorOrigin={
        anchorOrigin
          ? anchorOrigin
          : {
              vertical: "bottom",
              horizontal: "right",
            }
      }
    >
      {children}
    </Popover>
  );
};

export default BasePopover;
